/**
 *@中文
 *@params
 *@author WangPing
 *@date 2020-07-20
 */

export default {
  _not_interested_in_this_video: '当前视频不感兴趣吗？ %second%',
  _switch_one: '换一个',
  _next_reward_text: '再看一个视频获得100',
  _next_reward_button: '立即观看',
}